import { ChatbotView } from './types';
const isGuid = segment => {
  return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(segment);
};
const cleanUrl = rawUrl => {
  try {
    const url = new URL(rawUrl);
    const cleanedSegments = url.pathname.split('/').filter(seg => seg && seg !== 'html' && !isGuid(seg));
    return `${url.origin}/${cleanedSegments.join('/')}`;
  } catch {
    return rawUrl;
  }
};
export const getBiAreaAndPlatform = rawUrl => {
  try {
    const cleaned = cleanUrl(rawUrl);
    const url = new URL(cleaned);
    const segments = url.pathname.split('/').filter(Boolean); // remove empty

    if (url.hostname === 'manage.wix.com' && segments[0] === 'dashboard') {
      return {
        contextArea: segments.slice(1).join('/'),
        contextPlatform: 'bm'
      };
    }
    if (url.hostname === 'editor.wix.com') {
      const editorAreaAndPlatform = `${segments[0] ? `${segments[0]} ` : ''}editor`;
      return {
        contextArea: editorAreaAndPlatform,
        contextPlatform: editorAreaAndPlatform
      };
    }
    return {
      contextArea: segments.slice(1).join('/').trim(),
      contextPlatform: segments[0]
    };
  } catch (e) {
    console.error('Error extracting BI area and platform:', e);
    return {
      contextArea: 'unknown',
      contextPlatform: 'unknown'
    };
  }
};
export const getChatbotView = context => {
  const parentUrl = context == null ? void 0 : context.parentUrl;
  if (!parentUrl) {
    return undefined;
  }
  if (parentUrl.includes('www.wix.com/contact')) {
    return ChatbotView.helpWidgetContactPage;
  }
  return ChatbotView.helpWidgetFloating;
};
export const contextToBiEvent = context => {
  const {
    domain,
    page: {
      numLevels,
      urlChunks,
      topLevelRoute,
      queryParams
    },
    iframeUrlList,
    metaSiteId,
    parentUrl,
    userId,
    userExperience,
    mappingProduct,
    mappingUrl
  } = context;
  const queryParamsStringified = Object.keys(queryParams).reduce((acc, key) => {
    const value = queryParams[key];
    acc += `${key}=${value},`;
    return acc;
  }, '').replace(/,\s*$/, '');
  const {
    contextArea,
    contextPlatform
  } = getBiAreaAndPlatform(parentUrl);
  return {
    chatbot_view: getChatbotView(context),
    context_area: contextArea,
    context_domain: domain,
    context_iframeurllist: iframeUrlList.join(','),
    context_msid: metaSiteId,
    context_uuid: userId,
    context_platform: contextPlatform,
    context_parenturl: parentUrl,
    context_page_numlevels: numLevels,
    context_page_queryparams: queryParamsStringified,
    context_page_toplevelroute: topLevelRoute,
    context_page_urlchunks: urlChunks.join(','),
    mapping_url: mappingUrl,
    mapping_product: mappingProduct,
    user_experience: userExperience
  };
};
//# sourceMappingURL=contextToBiEvent.js.map